import classNames from "classnames";
import type { FC } from "react";
import styles from "./styles.module.scss";

type Props = {
  title: string;
  disabled: boolean;
  textColor: string;
};

export const PersonTitle: FC<Props> = ({ disabled, title, textColor }) => {
  return (
    <div
      style={{ color: textColor }}
      className={classNames(styles.root, { [styles.disabled]: disabled })}
    >
      {title}
    </div>
  );
};
